<script lang="ts" setup>
import { ref, watch, onMounted } from "vue";
import { usePGRESTAPIStore } from "../store/pgrest_api";
import PGRESTResult from "../classes/PGRESTResult";
import { ElMessage } from "element-plus";
import { Avatar, Bell, Edit, Delete, Document, Plus, RefreshLeft, CircleCheck, CircleClose, View, Watch } from "@element-plus/icons-vue";
import { storeToRefs } from "pinia";
import { useMainStore } from "../store/main";
import UserType from "../enums/UserType";
import { useSort } from "../composables/sort";
import { useI18n } from "vue-i18n";
import RestOfCollateral from "../classes/DB_Entities/RestOfCollaterals";
import { useGenericMethodsVariables } from "../composables/genericMethodsVariables";
import ChangeApprovalStatus from "../enums/ChangeApprovalStatus";
import AddEdit_NRECollateral from "../components/AddEdit_NRECollateral.vue";

const { showError } = useGenericMethodsVariables();
let filterHideRejected = ref(true);
let filterPendingNew = ref(false);
let isNewEntity = ref(false);
const { t } = useI18n({ useScope: "global" });
const { onSortChange, sortColumn, sortOrder } = useSort();
const pgrestapi = usePGRESTAPIStore();
const mainStore = useMainStore();
const { globalPortfolioID } = storeToRefs(mainStore);
const { globalDebtorID } = storeToRefs(mainStore);
const { globalLoanAgreementID } = storeToRefs(mainStore);
const DeleteDialogVisible = ref(false);

let dataList = ref([]);
let filterPending = ref(false);
let dataCount = ref(0);
let isLoading = ref(false);
let lastPage = ref(0);
let detailsVisible = ref(false);
let selectedRow = ref<number>(0);
let DeleteSelectedRow = ref(0);
let filterLoanAgreementNumber = ref<string>("");
let filterFullname = ref<string>("");
let filterVAT = ref<string>("");
let filterCollateralType = ref<string>("");
let filterCollateralNumber = ref<string>("");

let addEditVisible = ref(false);

let timer = ref<any>(null);
let viewOnly = ref(false);

watch(globalPortfolioID, async () => {
  if (mainStore.loggedUser.username !== '')
    await loadPage(1);
});

watch(globalDebtorID, async () => {
  if (mainStore.loggedUser.username !== '')
    await loadPage(1);
});

watch(globalLoanAgreementID, async () => {
  if (mainStore.loggedUser.username !== '')
    await loadPage(1);
});

const handleClickAdd = () => {
  addEditVisible.value = true;
  isNewEntity.value = true;
  selectedRow.value = -1;
};

const handleClickEdit = (row: any) => {
  viewOnly.value = !isEditable(row);
  selectedRow.value = row.id;
  isNewEntity.value = false;
  addEditVisible.value = true;
};

const handleClickDelete = (row_id: number) => {
  DeleteSelectedRow.value = row_id;
  DeleteDialogVisible.value = true;
};

onMounted(async () => {
  loadPage(1);
});

const deleteSelectedNRECollateral = async () => {
  let DeletePendingApprovals = await pgrestapi.delete_data(
    "entity_rest_of_collaterals_changes?entity_id=eq." + DeleteSelectedRow.value
  );

  if (DeletePendingApprovals.error) {
    ElMessage({
      showClose: true,
      message: DeletePendingApprovals.error.message,
      type: "error",
    });

    return;
  }

  let result = await pgrestapi.delete_data("rest_of_collaterals?id=eq." + DeleteSelectedRow.value);

  if (result.error) {
    showError(result.error.message);

    DeleteDialogVisible.value = false;
    return;
  }

  onDelete();
};

const onDelete = async () => {
  ElMessage({
    showClose: true,
    message: "NRE Collateral Deleted Successfully",
    type: "success",
    duration: 1000,
  });

  DeleteDialogVisible.value = false;
  DeleteSelectedRow.value = -1;
  loadPage(lastPage.value);
};

const loadPage = async (page: number) => {
  isLoading.value = true;
  // console.log("page is" + page);
  if (page <= 0) {
    page = 1;
  }

  lastPage.value = page;
  page = page - 1;

  let filterUrl = "";

  if (filterPending.value) {
    filterUrl += "&pending_approvals=gt.0";
  }

  if (filterLoanAgreementNumber.value !== "") {
    filterUrl += `&loan_agreement_ar_sumbashs=eq.${filterLoanAgreementNumber.value}`;
  }

  if (filterFullname.value !== "") {
    filterUrl += `&fullname=ilike.*${filterFullname.value}*`;
  }

  if (filterVAT.value !== "") {
    filterUrl += `&vat_number=ilike.*${filterVAT.value}*`;
  }

  if (filterPendingNew.value) {
    filterUrl += "&approve_status=eq.0";
  }

  if (filterHideRejected.value) {
    filterUrl += "&approve_status=neq.2";
  }

  if (filterCollateralType.value !== "") {
    filterUrl += `&type=eq.${filterCollateralType.value}`;
  }
  if (filterCollateralNumber.value !== "") {
    filterUrl += `&ar_kalimatos=eq.${filterCollateralNumber.value}`;
  }
  if (sortOrder.value === "") {
    filterUrl += `&order=id.desc`;
  }
  if (sortOrder.value !== "") {
    // if (filterUrl === "") {
    //   filterUrl = "?";
    // }
    filterUrl += `&order=${sortColumn.value}.${sortOrder.value}`;
  }

  let selectedPortfolio = "";
  let selectedDebtor = "";
  let selectedLoanAgreement = "";
  let addedFilter = "";

  if (mainStore.globalPortfolioID !== "" && mainStore.globalPortfolioID !== undefined) {
    selectedPortfolio = mainStore.globalPortfolioID;
      addedFilter += "&portfolio=eq." + selectedPortfolio;
  }

  if (mainStore.globalDebtorID !== "" && mainStore.globalDebtorID !==undefined) {
    selectedDebtor = mainStore.globalDebtorID;
    addedFilter += "&debtor_id=eq." + selectedDebtor;
  }

  if (mainStore.globalLoanAgreementID !== "" && mainStore.globalLoanAgreementID !== undefined) {
    selectedLoanAgreement = mainStore.globalLoanAgreementID;
    addedFilter += "&loan_agreement_id=eq." + selectedLoanAgreement;
  }

  // let result: PGRESTResult = await pgrestapi.getPaginated(
  //   "rest_of_collaterals?select=*,loan_agreement!inner(*, debtor!inner(*,portfolio!inner(*)))" +
  //   addedFilter +
  //   filterUrl,
  //   page
  // );
  // console.log("page:" + page);
  if (mainStore.loggedUser.user_type == UserType.Agent) {
    addedFilter += `&allowed_users=cs.{${mainStore.loggedUser.id}}`;
  } else if (mainStore.loggedUser.user_type == UserType.Supervisor) {
    addedFilter += `&portfolio_allowed_users=cs.{${mainStore.loggedUser.id}}`;
  }
  // console.log("******666");
  // console.log(page);

  let result: PGRESTResult = await pgrestapi.getPaginated(
    "view_mosrest_of_collaterals_view2?select=*" + addedFilter + filterUrl,
    page
  );

  if (result.error) {
    showError(result.error.message);

    return;
  }

  if (result.headers)
    dataCount.value = parseInt(result.headers["content-range"].split("/")[1]);

  dataList.value = result.data;

  isLoading.value = false;
};

const onSave = async () => {
  selectedRow.value = -1;
  ElMessage({
    showClose: true,
    message: "NRE Collateral updated",
    type: "success",
    duration: 1000,
  });
  detailsVisible.value = false;

  loadPage(lastPage.value);
};

const onFailSave = async () => {
  selectedRow.value = -1;
  ElMessage({
    showClose: true,
    message: "NRE Collateral failed to update",
    type: "error",
    duration: 2000,
  });

  detailsVisible.value = false;
};

const filterChanged = async (value: string) => {
  if (timer.value !== 0) {
    clearTimeout(timer.value);
  }

  timer.value = setTimeout(() => {
    loadPage(1);
    timer.value = 0;
  }, 500);
};

const onAdd = async () => {
  ElMessage({
    showClose: true,
    message: "NRE Collateral added Successfully",
    type: "success",
    duration: 1000,
  });

  addEditVisible.value = false;

  loadPage(lastPage.value);
};

const localSortChange = async (sortObj: any) => {
  onSortChange(sortObj);
  await loadPage(lastPage.value);
};

const pendingFilterChange = async () => {
  await loadPage(1);
};

const getTranslationCollateralType = (row: any, column: any) => {
  return t("CollateralTypes." + row[column.property]);
};

const CollateralTypeOptions = [
  {
    value: "listed_shares",
    label: t("CollateralTypes.listed_shares"),
  },
  {
    value: "unlisted_shares",
    label: t("CollateralTypes.unlisted_shares"),
  },
  {
    value: "deposits",
    label: t("CollateralTypes.deposits"),
  },
  {
    value: "pledged_claims",
    label: t("CollateralTypes.pledged_claims"),
  },
  {
    value: "warehouse_receipt",
    label: t("CollateralTypes.warehouse_receipt"),
  },
  {
    value: "checks",
    label: t("CollateralTypes.checks"),
  },
  {
    value: "bill_of_exchange",
    label: t("CollateralTypes.bill_of_exchange"),
  },
  {
    value: "movable_collaterals",
    label: t("CollateralTypes.movable_collaterals"),
  },
];

const entityApprove = async (entity_id: number, accepted: boolean) => {
  // console.log("entity id", entity_id, "approved", accepted);
  if (entity_id === undefined || entity_id === null) {
    return;
  }
  // console.log("a");
  let result = await pgrestapi.patch(
    `${RestOfCollateral.getTableNameStatic()}?id=eq.${entity_id}`,
    {
      approve_status: accepted ? ChangeApprovalStatus.Approved : ChangeApprovalStatus.Rejected,
    }
  );

  // console.log("entity_approve", RestOfCollateral.getTableNameStatic(), entity_id);

  ElMessage({
    showClose: true,
    message: `NRE Collateral${!accepted ? " not " : " "}approved`,
    type: "success",
    duration: 1000,
  });

  await loadPage(lastPage.value);
};

const isEditable = (row: any) => {
  return (row.debtor_approve_status === 1 && row.loan_agreement_approve_status === 1);
}

const onCloseAddEdit = () => {
  addEditVisible.value = false;
  selectedRow.value = -1;
};

</script>

<template>
  <div class="content-wrapper" v-loading="isLoading">
    <el-row :gutter="10">
      <el-col :span="12">
        <h3 class="heading-page">
          {{ $t("NRECollateralsView.nre_collaterals") }} ({{ dataCount }})
        </h3>
      </el-col>
    </el-row>
    <div style="margin: 30px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model="filterFullname" class="client-input" :placeholder="$t('DebtorView.company_name')"
            @input="filterChanged" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="filterVAT" class="client-input" :placeholder="$t('DebtorView.tax_registration_nbr')"
            @input="filterChanged" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="filterCollateralNumber" class="client-input"
            :placeholder="$t('RealEstateCollateralsView.collateral_nbr')" @input="filterChanged" />
        </el-col>
        <el-col :span="6">
          <el-select clearable v-model="filterCollateralType" class="m-2 client-input"
            :placeholder="$t('nre_collaterals_category.collateral_type')" value-key="id" @change="filterChanged"
            style="width: 100%">
            <el-option v-for="item in CollateralTypeOptions" :key="item.value"
              :label="$t('CollateralTypes.' + item.value)" :value="item.value" />
          </el-select>
        </el-col>
      </el-row>
    </div>

    <div>
      <el-row :gutter="10" style="margin: 10px; margin-top: 15px">
        <el-col :span="12" class="realestate-add-new-btn">
          <el-switch v-model="filterPending" size="small" :active-text="$t('global.pending_changes')" inactive-text=""
            @change="pendingFilterChange()" style="float: left" />
          <el-switch v-model="filterPendingNew" size="small" :active-text="$t('global.pending_changes_new_entities')"
            inactive-text="" @change="pendingFilterChange()" style="float: left" />
          <el-switch v-model="filterHideRejected" size="small" :active-text="$t('global.hide_rejected_entities')"
            inactive-text="" @change="pendingFilterChange()" style="float: left" />
        </el-col>
        <el-col :span="12" class="realestate-add-new-btn">
          <el-button link type="primary" size="small" class="btn-add" @click="loadPage(lastPage)"
            style="float: right; margin: 2.5px" :icon="RefreshLeft" />
          <el-button link type="primary" size="small" class="btn-add" style="float: right; margin: 2.5px"
            @click="handleClickAdd()" :icon="Plus" />
        </el-col>
      </el-row>
    </div>

    <el-table v-loading="isLoading" :data="dataList" stripe border table-layout="fixed" sortable="custom"
      @sort-change="localSortChange" size="small">
      <el-table-column sortable fixed prop="id" label="ID" />
      <el-table-column sortable fixed prop="loan_agreement_ar_sumbashs"
        :label="$t('NRECollateralsView.loan_agreement')" />
      <el-table-column fixed prop="fullname" :label="$t('DebtorView.company_name')" sortable />
      <el-table-column fixed prop="vat_number" :label="$t('DebtorView.tax_registration_nbr')" sortable />
      <el-table-column fixed prop="ar_kalimatos" :label="$t('RealEstateCollateralsView.collateral_nbr')" sortable />
      <el-table-column fixed prop="type" :formatter="getTranslationCollateralType"
        :label="$t('nre_collaterals_category.collateral_type')" sortable />
      <el-table-column fixed prop="portf_name" :label="$t('DebtorDetailsView.portfolio')" sortable />

      <el-table-column sortable fixed prop="pending_approvals" :label="$t('global.pending_approvals')" />
      <el-table-column fixed="right" :label="$t('global.operations')" width="180">
        <template #default="scope">
          <el-button link type="primary" size="small" class="btn-detail" @click="handleClickEdit(scope.row)"
            :icon="isEditable(scope.row) ? Edit : View" />
          <el-button v-if="mainStore.loggedUser.user_type === UserType.Administrator" link type="primary" size="small"
            class="btn-delete" @click="handleClickDelete(scope.row.id)" :icon="Delete" />
          <el-tooltip v-if="scope.row.approve_status == 0 && mainStore.loggedUser.user_type === UserType.Agent"
            effect="dark" content="Pending Supervisor approval" placement="top">
            <el-button size="small" type="primary" class="btn-warn" :icon="Watch" circle />
          </el-tooltip>
          <span v-if="
            mainStore.loggedUser.user_type < UserType.Agent &&
            scope.row.approve_status === 0
          ">
            <el-button class="btn-accept_square" @click="entityApprove(scope.row.id, true)" :icon="CircleCheck" />
            <el-button class="btn-reject_square" @click="entityApprove(scope.row.id, false)" :icon="CircleClose" />
          </span>
          <el-popover v-if="scope.row.pending_approvals > 0" placement="top-start" title="" :width="145" trigger="hover"
            :content="$t('global.pending_changes')">
            <template #reference>
              <el-button :icon="Bell" circle size="small" style="background-color: coral; border: 0px; color: white" />
            </template>
          </el-popover>
          <el-popover v-if="scope.row.debtor_approve_status !== 1" placement="top-start" title="" :width="205"
            trigger="hover" :content="$t('global.debtor_not_approved')">
            <template #reference>
              <el-button :icon="Avatar" circle size="small"
                style="background-color: blueviolet; border: 0px; color: white" />
            </template>
          </el-popover>
          <el-popover v-if="scope.row.loan_agreement_approve_status !== 1" placement="top-start" title="" :width="265"
            trigger="hover" :content="$t('global.loan_agreement_not_approved')">
            <template #reference>
              <el-button :icon="Document" circle size="small"
                style="background-color: coral; border: 0px; color: white" />
            </template>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>

    <div>
      <el-pagination size="small" layout="prev, pager, next" :page-size="10" :total="dataCount" v-model:current-page="lastPage"
        @current-change="loadPage" />
    </div>

    <el-dialog v-if="addEditVisible" v-model="addEditVisible" @update:model-value="onCloseAddEdit"
      :title="isNewEntity ? 'Add NRE Collateral' : 'NRE Collateral Details'">
      <AddEdit_NRECollateral :nrecollateralid="selectedRow" @close="onCloseAddEdit"
        @save="onAdd" :view_only="viewOnly" @fail-save="onFailSave" />
    </el-dialog>

    <el-dialog v-model="DeleteDialogVisible" title="NRE Collateral Delete" width="50%">
      <span>Are you sure you want to delete this NRE Collateral and all its properties?</span>
      <template #footer #default="scope">
        <span class="dialog-footer">
          <el-button @click="DeleteDialogVisible = false">{{ $t('generic.cancel') }}</el-button>
          <el-button type="primary" @click="deleteSelectedNRECollateral()">{{
            $t('generic.delete')
          }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<style scoped></style>
